"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCircle = void 0;
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.ErrorCircle = function (props) {
    return (React.createElement(Icon_styled_1.StyledSvg, { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "11", cy: "11", r: "11", fill: common_styles_1.negative }),
        React.createElement("path", { d: "M7.5 14.5L14.5 7.5", stroke: common_styles_1.white, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M7.5 7.5L14.5 14.5", stroke: common_styles_1.white, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=error-circle.js.map